import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team-style-one',
  templateUrl: './team-style-one.component.html',
  styleUrls: ['./team-style-one.component.scss']
})
export class TeamStyleOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
